export enum ClevehrDebounceTime {
    extraShort = 125,
    veryShort = 250,
    short = 500,
    normal = 1000,
    long = 2000,
    veryLong = 4000,
}
